import React, { useState, useEffect, useRef } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import leftArrowSvg from "../../../Assets/leftArrowSvg.svg";
import rightArrowSvg from "../../../Assets/rightArrowSvg.svg";
import AvatrHover from "../../../Assets/AvatrHover.png";
import watchbtn from "../../../Assets/watchbtn.png";
import closeImg from "../../../Assets/closeImg.png";
import tool_tip_icon from "../../../Assets/tool_tip_icon.svg";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useGoogleLogin } from "@react-oauth/google";
import {
  getLocationID,
  GOOGLE_CLIENT_ID,
  GOOGLE_CLIENT_SECRET,
  GOOGLE_REDIRECTION_URL,
} from "../../../ServiceConnection/serviceconnection";
import {
  get_all_data_onboarding,
  insert_update_business_data_onboarding,
  server_post_data,
} from "../../../ServiceConnection/serviceconnection";
import { handleError } from "../../../CommonJquery/CommonJquery";
import "../../CSS/NewOnboading/Step5.css";

let accessToken = null;
let refreshToken = null;
let accountId = null;

export default function Step5Page({ onBack, onNext }) {
  const [error, setError] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const tooltipTimeout = useRef(null);
  const [SelectedReviewData, setSelectedReviewData] = useState([]);
  const [focusedInputIndex, setFocusedInputIndex] = useState(null);

  const handleMouseEnter = (index) => {
    clearTimeout(tooltipTimeout.current);
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    tooltipTimeout.current = setTimeout(() => {
      setHoveredIndex(null);
    }, 150);
  };

  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [businessTypes, setbusinessTypes] = useState([]);
  const [businessImage, setbusinessImage] = useState("");

  // FIX: selectedHotel now stores the unique Google location "name" (id),
  // not an array index — matches the SetupChannels fix so filtering/search
  // never points at the wrong row.
  const [selectedHotel, setSelectedHotel] = useState(null);
  const [LocatrionList, setLocatrionList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [locationSearchQuery, setLocationSearchQuery] = useState("");
  const [loadingStates, setLoadingStates] = useState({});
  const [connectedStates, setConnectedStates] = useState({});
  const [linkErrors, setLinkErrors] = useState({});
  const [isAllLinksFilled, setIsAllLinksFilled] = useState(true);

  // Tracks which row (index) in businessTypes triggered the currently
  // in-flight OAuth flow (Google / Play Store / Facebook), so we know which
  // button's loading/connected state to update once the popup finishes.
  const pendingIndexRef = useRef(null);

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("flag", "5");
    await server_post_data(get_all_data_onboarding, fd)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          setbusinessTypes(final_data.review_linkss_data2);
          setbusinessImage(final_data.review_linkss_link);
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  const handleNext = async () => {
    // OAuth platforms (Google/Play Store/Facebook) never carry a
    // review_link — they're validated by having an accesstoken instead.
    // Link-based platforms still need a non-empty review_link.
    const allLinksFilled = businessTypes.every((platform) =>
      parseInt(platform.api_or_link) === 1
        ? !!platform.accesstoken
        : platform.review_link && platform.review_link.trim() !== "",
    );

    if (!allLinksFilled) {
      setIsAllLinksFilled(false);
    } else {
      setIsAllLinksFilled(true);
      let error_show = true;
      setIsLoading(true);
      let fd_from = new FormData();
      fd_from.append("flag", "5");
      for (let i = 0; i < businessTypes.length; i++) {
        fd_from.append(
          "review_linkss_data_" + i,
          JSON.stringify(businessTypes[i]),
        );
        if (
          parseInt(businessTypes[i].api_or_link) === 0 &&
          (!businessTypes[i].review_link ||
            businessTypes[i].review_link.trim() === "")
        ) {
          error_show = false;
        }
        if (
          parseInt(businessTypes[i].api_or_link) === 1 &&
          !businessTypes[i].accesstoken
        ) {
          error_show = false;
        }
      }
      fd_from.append("review_count", businessTypes.length);
      if (error_show) {
        await server_post_data(insert_update_business_data_onboarding, fd_from)
          .then((Response) => {
            setIsLoading(false);
            let data = Response.message.split("~@~");
            const final_data = JSON.parse(data[1]);
            if (parseInt(data[0]) === 1) {
              handleError(final_data.message);
            } else {
              onNext(final_data.step_save);
            }
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      } else {
        handleError("Please Fill All The Links");
      }
    }
  };

  const handleRadioChange = (hotelName) => {
    setSelectedHotel(hotelName);
  };

  // FIX: this previously did nothing useful — it referenced module-level
  // `locationId`, which was declared but NEVER set to the chosen hotel, so
  // Google onboarding "connect" silently saved an empty/undefined location.
  // It now actually posts the selection to the backend (same shape as
  // SetupChannels' save_googole_reviews) and only marks the row connected
  // once the server confirms it. No manual review-link is required for
  // Google anymore — location selection is enough.
  const savelocationID = async () => {
    const chosenHotel = LocatrionList.find(
      (hotel) => hotel.name === selectedHotel,
    );
    if (!chosenHotel) return;

    const googleIndex = businessTypes.findIndex(
      (item) => item.review_name === "Google",
    );

    setShowLoaderAdmin(true);
    let formdata = new FormData();
    formdata.append("accessToken", accessToken);
    formdata.append("accountId", accountId);
    formdata.append("refreshToken", refreshToken);
    formdata.append("locationId", chosenHotel.name);
    formdata.append("url_for_place", chosenHotel.metadata?.newReviewUri || "");
    formdata.append("placeId", chosenHotel.metadata?.placeId || "");
    formdata.append("rll_id", SelectedReviewData.rll_id);
    formdata.append("review_name", SelectedReviewData.review_name);
    formdata.append("review_website", SelectedReviewData.review_website);
    formdata.append("review_logo", SelectedReviewData.review_logo);

    setbusinessTypes((prev) =>
      prev.map((item) =>
        item.review_name === "Google"
          ? {
              ...item,
              accesstoken: accessToken,
              refreshtoken: refreshToken,
              accountid: accountId,
              locationid: chosenHotel.name,
            }
          : item,
      ),
    );
    if (googleIndex !== -1) {
      setConnectedStates((prev) => ({ ...prev, [googleIndex]: true }));
    }

    if (googleIndex !== -1) {
      setLoadingStates((prev) => ({ ...prev, [googleIndex]: false }));
    }
    closeLocationModal();
  };

  // Handle input focus and blur for dynamic placeholder
  const handleInputFocus = (index) => {
    setFocusedInputIndex(index);
  };

  const handleInputBlur = () => {
    setFocusedInputIndex(null);
  };

  const handleReviewLinkChange = (index, value) => {
    setbusinessTypes((prev) =>
      prev.map((item, i) =>
        i === index ? { ...item, review_link: value } : item,
      ),
    );
    const allLinksFilled = businessTypes.every((platform, i) =>
      parseInt(platform.api_or_link) === 1
        ? !!platform.accesstoken
        : i === index
          ? value && value.trim() !== ""
          : platform.review_link && platform.review_link.trim() !== "",
    );
    setIsAllLinksFilled(allLinksFilled);
    setLinkErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[index];
      return newErrors;
    });
  };

  // FIX: this used to just log the platform name and, for every platform
  // that isn't explicitly "Google"/"Android Play Store"/"Facebook", call
  // save_Link_url_manually() after an artificial 2s delay — meanwhile the
  // ACTUAL login()/Playlogin()/initializeAndLoginWithFacebook() calls were
  // commented out, so clicking "Connect" on Google/Play Store/Facebook did
  // nothing except spin for 2 seconds and mark itself "connected" with no
  // real token. Now each platform triggers its real OAuth flow, and the
  // loading/connected state is resolved by that flow's own success handler
  // (login -> fetchAccountAndLocationIds -> master_data_get_google -> modal
  // -> savelocationID for Google; the respective onSuccess handlers for
  // Play Store and Facebook).
  //
  // FIX 2: OAuth platforms (api_or_link === 1) don't need a pasted link at
  // all — the link-required validation now only applies to platforms that
  // are genuinely link-based (api_or_link === 0).
  const handleclicklogin = (item, Reconnect, index) => {
    const normalizedReviewName = item.review_name.trim();
    const isOAuthPlatform = parseInt(item.api_or_link) === 1;

    if (!isOAuthPlatform) {
      const link = item.review_link || "";
      if (!link.trim() || !link.includes(".")) {
        setLinkErrors((prev) => ({ ...prev, [index]: true }));
        return;
      }
      setLinkErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
    }

    setSelectedReviewData(item);

    if (normalizedReviewName === "Google") {
      pendingIndexRef.current = index;
      setLoadingStates((prev) => ({ ...prev, [index]: true }));
      login();
    } else if (normalizedReviewName === "Android Play Store") {
      pendingIndexRef.current = index;
      setLoadingStates((prev) => ({ ...prev, [index]: true }));
      Playlogin();
    } else if (normalizedReviewName === "Facebook") {
      pendingIndexRef.current = index;
      setLoadingStates((prev) => ({ ...prev, [index]: true }));
      initializeAndLoginWithFacebook();
    } else {
      // Plain link-based platforms: the link is already saved into
      // businessTypes live (see handleReviewLinkChange), so just mark
      // this row as connected.
      setConnectedStates((prev) => ({ ...prev, [index]: true }));
    }
  };

  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      try {
        // Exchange the authorization code for an access token
        const response = await axios.post(
          "https://oauth2.googleapis.com/token",
          null,
          {
            params: {
              code: codeResponse.code, // This is the authorization code
              client_id: GOOGLE_CLIENT_ID,
              client_secret: GOOGLE_CLIENT_SECRET,
              redirect_uri: GOOGLE_REDIRECTION_URL,
              grant_type: "authorization_code",
            },
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
        );
        accessToken = response.data.access_token;
        refreshToken = response.data.refresh_token;
        fetchAccountAndLocationIds(response.data.access_token);
      } catch (error) {
        console.error("Error exchanging code for token:", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
        }
        if (pendingIndexRef.current !== null) {
          setLoadingStates((prev) => ({
            ...prev,
            [pendingIndexRef.current]: false,
          }));
        }
      }
    },
    onError: () => {
      if (pendingIndexRef.current !== null) {
        setLoadingStates((prev) => ({
          ...prev,
          [pendingIndexRef.current]: false,
        }));
      }
    },
    flow: "auth-code", // Using authorization code flow
    scope: "https://www.googleapis.com/auth/business.manage", // Add the required scope
  });

  const Playlogin = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      try {
        // Exchange the authorization code for an access token
        const response = await axios.post(
          "https://oauth2.googleapis.com/token",
          null,
          {
            params: {
              code: codeResponse.code, // This is the authorization code
              client_id: GOOGLE_CLIENT_ID,
              client_secret: GOOGLE_CLIENT_SECRET,
              redirect_uri: GOOGLE_REDIRECTION_URL,
              grant_type: "authorization_code",
            },
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          },
        );
        accessToken = response.data.access_token;
        refreshToken = response.data.refresh_token;

        setbusinessTypes((prev) =>
          prev.map((item) =>
            item.review_name === "Android Play Store"
              ? {
                  ...item,
                  accesstoken: accessToken,
                  refreshtoken: refreshToken,
                  accountid: accountId,
                }
              : item,
          ),
        );

        const psIndex = businessTypes.findIndex(
          (item) => item.review_name === "Android Play Store",
        );
        if (psIndex !== -1) {
          setConnectedStates((prev) => ({ ...prev, [psIndex]: true }));
          setLoadingStates((prev) => ({ ...prev, [psIndex]: false }));
        }
      } catch (error) {
        console.error("Error exchanging code for token:", error);
        if (error.response) {
          console.error("Response data:", error.response.data);
        }
        if (pendingIndexRef.current !== null) {
          setLoadingStates((prev) => ({
            ...prev,
            [pendingIndexRef.current]: false,
          }));
        }
      }
    },
    onError: () => {
      if (pendingIndexRef.current !== null) {
        setLoadingStates((prev) => ({
          ...prev,
          [pendingIndexRef.current]: false,
        }));
      }
    },
    flow: "auth-code",
    scope: "https://www.googleapis.com/auth/androidpublisher",
  });

  const initializeAndLoginWithFacebook = () => {
    // Check if FB SDK is already loaded
    if (!window.FB) {
      // Load SDK dynamically if not present
      (function (d, s, id) {
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        const js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
        js.onload = () => {
          window.FB.init({
            appId: "1132956361970766", // Replace with your Facebook App ID
            cookie: true,
            xfbml: true,
            version: "v21.0",
          });
          loginWithFacebook(); // Trigger login after initialization
        };
      })(document, "script", "facebook-jssdk");
    } else {
      // If SDK is already loaded, just call login
      loginWithFacebook();
    }
  };

  const fetchAccountAndLocationIds = async (token) => {
    try {
      // Step 1: Fetch Accounts
      const accountResponse = await axios.get(
        "https://mybusinessaccountmanagement.googleapis.com/v1/accounts",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const accounts = accountResponse.data.accounts;
      if (!accounts || accounts.length === 0) {
        setError("No accounts found");
        if (pendingIndexRef.current !== null) {
          setLoadingStates((prev) => ({
            ...prev,
            [pendingIndexRef.current]: false,
          }));
        }
        return;
      }

      const accountIdlet = accounts[0].name.split("/")[1]; // Extract accountId
      accountId = accountIdlet;
      master_data_get_google(token, accountIdlet);
    } catch (err) {
      console.error(
        "Error fetching Account or Location IDs:",
        err.response?.data || err.message,
      );
      setError(err.response?.data?.error?.message || "An error occurred");
      if (pendingIndexRef.current !== null) {
        setLoadingStates((prev) => ({
          ...prev,
          [pendingIndexRef.current]: false,
        }));
      }
    }
  };

  const master_data_get_google = async (accessToken, accountId) => {
    setShowLoaderAdmin(true);
    let formdata = new FormData();
    formdata.append("accessToken", accessToken);
    formdata.append("accountId", accountId);
    await server_post_data(getLocationID, formdata)
      .then((Response) => {
        let data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          setLocatrionList(final_data.locations);
          setSelectedHotel(
            final_data.locations?.length ? final_data.locations[0].name : null,
          );
          setLocationSearchQuery("");
          handleShowModal();
        }
        setShowLoaderAdmin(false);
        // Modal is up now — clear the button spinner, "Connect" finishes
        // when the user picks a location and hits Save (see savelocationID).
        if (pendingIndexRef.current !== null) {
          setLoadingStates((prev) => ({
            ...prev,
            [pendingIndexRef.current]: false,
          }));
        }
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
        if (pendingIndexRef.current !== null) {
          setLoadingStates((prev) => ({
            ...prev,
            [pendingIndexRef.current]: false,
          }));
        }
      });
  };

  // Login function to handle Facebook login and fetch page access token
  const loginWithFacebook = () => {
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          const userAccessToken = response.authResponse.accessToken;

          // Fetch user's managed pages
          window.FB.api("/me/accounts", (pagesResponse) => {
            if (pagesResponse && !pagesResponse.error) {
              // Extract page access tokens
              pagesResponse.data.forEach((page) => {
                setbusinessTypes((prev) =>
                  prev.map((item) =>
                    item.review_name === "Facebook"
                      ? {
                          ...item,
                          accesstoken: page.access_token,
                          refreshtoken: userAccessToken,
                          accountid: "",
                          locationid: "",
                        }
                      : item,
                  ),
                );
              });

              const fbIndex = businessTypes.findIndex(
                (item) => item.review_name === "Facebook",
              );
              if (fbIndex !== -1) {
                setConnectedStates((prev) => ({ ...prev, [fbIndex]: true }));
                setLoadingStates((prev) => ({ ...prev, [fbIndex]: false }));
              }
            } else {
              console.error("Error fetching pages:", pagesResponse.error);
              if (pendingIndexRef.current !== null) {
                setLoadingStates((prev) => ({
                  ...prev,
                  [pendingIndexRef.current]: false,
                }));
              }
            }
          });
        } else {
          console.error("User cancelled login or did not fully authorize.");
          if (pendingIndexRef.current !== null) {
            setLoadingStates((prev) => ({
              ...prev,
              [pendingIndexRef.current]: false,
            }));
          }
        }
      },
      {
        scope:
          "public_profile,email,pages_read_engagement,pages_manage_metadata,pages_read_user_content",
      },
    );
  };

  const handleShowModal = () => {
    setShowModal(!showModal);
  };

  // FIX: proper close for the "Manage Location" modal — also resets the
  // search box and clears the Google row's spinner if the user backs out
  // without picking a location, instead of leaving it stuck loading.
  const closeLocationModal = () => {
    setShowModal(false);
    setLocationSearchQuery("");
    const googleIndex = businessTypes.findIndex(
      (item) => item.review_name === "Google",
    );
    if (googleIndex !== -1) {
      setLoadingStates((prev) => ({ ...prev, [googleIndex]: false }));
    }
  };

  // Filtered list for the location search box (title or numeric id match)
  const filteredLocationList = LocatrionList.filter((hotel) => {
    if (!locationSearchQuery.trim()) return true;
    const q = locationSearchQuery.toLowerCase();
    const idPart = hotel.name?.split("/")[1] || "";
    return hotel.title?.toLowerCase().includes(q) || idPart.includes(q);
  });

  const handleEditFunction = (platform, index) => {
    setConnectedStates((prev) => ({
      ...prev,
      [index]: false,
    }));
  };

  return (
    <div>
      {" "}
      <div className="col-xl-8 col-lg-10 mx-auto">
        <div className="tell_aboutSection ">
          <div className="height_ovr_flow_clss_step5">
            <h1>Let's Connect Your Review Channels</h1>
            <div className="lebelDiv">
              <label>
                These links will appear when your customer scans your QR <br />{" "}
                helping you collect feedback where it counts the most.
              </label>
            </div>

            {!isAllLinksFilled && (
              <span
                style={{ width: "100%", color: "red", textAlign: "center" }}
              >
                Please Fill All Links
              </span>
            )}

            <div
              className="bussiness_typeCard p-0"
              style={{ position: "relative" }}
            >
              <div className="d-flex justify-content-center ">
                <div className="review_link_div w-100">
                  <h4 className="revie_linkText">Review Link</h4>
                  {businessTypes.map((platform, index) => {
                    const isOAuthPlatform =
                      parseInt(platform.api_or_link) === 1;
                    return (
                      <React.Fragment key={index}>
                        <div className="review_contnt">
                          <div className="col-sm-1 social_width_clss">
                            <div className="social_icbon_div">
                              <img
                                src={businessImage + platform.review_logo}
                                alt={platform.review_name}
                              />
                            </div>
                          </div>
                          <div className="col-sm-10 review_inpt_width_clss">
                            <div
                              className="link_past_div"
                              style={{ position: "relative" }}
                            >
                              {isOAuthPlatform ? (
                                // OAuth platform: no link to type — just a
                                // name label and a real Connect button that
                                // launches the OAuth popup directly.
                                <div className="oauthConnectRow">
                                  <span className="oauthPlatformLabel">
                                    {connectedStates[index]
                                      ? `${platform.review_name} connected`
                                      : `Connect your ${platform.review_name} account`}
                                  </span>
                                  <button
                                    type="button"
                                    className="connect_botttn"
                                    onClick={() => {
                                      if (connectedStates[index]) {
                                        handleEditFunction(platform, index);
                                      } else {
                                        handleclicklogin(platform, "", index);
                                      }
                                    }}
                                    disabled={loadingStates[index]}
                                    style={{
                                      minWidth: "80px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      opacity: loadingStates[index] ? 0.7 : 1,
                                      cursor: loadingStates[index]
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    {loadingStates[index] ? (
                                      <div className="loading-dots">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                      </div>
                                    ) : connectedStates[index] ? (
                                      "Edit"
                                    ) : (
                                      "Connect"
                                    )}
                                  </button>
                                </div>
                              ) : (
                                // Link-based platform: paste a link, then
                                // Connect just marks it saved.
                                <>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={platform.review_link || ""}
                                    placeholder={
                                      focusedInputIndex === index
                                        ? `Enter or Paste your ${platform.review_name} Link`
                                        : platform.review_name +
                                          " review instructions go here."
                                    }
                                    onFocus={() => handleInputFocus(index)}
                                    onBlur={handleInputBlur}
                                    onChange={(e) =>
                                      handleReviewLinkChange(
                                        index,
                                        e.target.value,
                                      )
                                    }
                                    readOnly={connectedStates[index]}
                                  />

                                  <button
                                    type="button"
                                    className="connect_botttn"
                                    onClick={() => {
                                      if (connectedStates[index]) {
                                        handleEditFunction(platform, index);
                                      } else {
                                        handleclicklogin(platform, "", index);
                                      }
                                    }}
                                    disabled={
                                      loadingStates[index] ||
                                      (!connectedStates[index] &&
                                        (!platform.review_link ||
                                          platform.review_link.trim() === ""))
                                    }
                                    style={{
                                      minWidth: "80px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      opacity: loadingStates[index]
                                        ? 0.7
                                        : !connectedStates[index] &&
                                            (!platform.review_link ||
                                              platform.review_link.trim() ===
                                                "")
                                          ? 0.5
                                          : 1,
                                      cursor:
                                        loadingStates[index] ||
                                        (!connectedStates[index] &&
                                          (!platform.review_link ||
                                            platform.review_link.trim() === ""))
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    {loadingStates[index] ? (
                                      <div className="loading-dots">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                      </div>
                                    ) : connectedStates[index] ? (
                                      "Edit"
                                    ) : (
                                      "Connect"
                                    )}
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                          <div className="col-sm-1 tool_tip_width_clss">
                            <div
                              className="tooltipIcon"
                              style={{ cursor: "default" }}
                            >
                              <img
                                src={tool_tip_icon}
                                className="tool_tip_icon"
                                alt="tool_tip_icon"
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                                style={{ cursor: "pointer" }}
                              />
                              {hoveredIndex === index && (
                                <div
                                  className="tool_tip_hover_div"
                                  onMouseEnter={() => handleMouseEnter(index)}
                                  onMouseLeave={handleMouseLeave}
                                >
                                  <div style={{ position: "relative" }}>
                                    <img
                                      src={closeImg}
                                      className="closeImgTooltIp"
                                      alt="close"
                                    />
                                    <img
                                      src={AvatrHover}
                                      className="AvatrHover"
                                      alt="AvatrHover"
                                    />
                                    <p>
                                      {platform.review_name +
                                        " review instructions."}
                                    </p>
                                    <div className="watchBtttn">
                                      <a
                                        href={
                                          platform.review_name +
                                          " review instructions."
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img src={watchbtn} alt="watchbtn" />
                                        <label>Watch</label>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {linkErrors[index] && !isOAuthPlatform && (
                          <span className="review_error">
                            Please paste or fill a valid link
                          </span>
                        )}
                      </React.Fragment>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>

          <div
            className="pre_next_bttn_div"
            style={{ paddingLeft: "0", paddingRight: "0" }}
          >
            <button className="prevBtn m-0" onClick={onBack}>
              <img
                src={leftArrowSvg}
                alt="left"
                title="left"
                className="leftArrowSvg"
              />
              Back
            </button>
            <button className="nextBtn m-0" onClick={handleNext}>
              Next
              <img
                src={rightArrowSvg}
                alt="right"
                title="right"
                className="right_arrw_svg"
              />
            </button>
          </div>
        </div>
      </div>
      {/**-----------location Card Modal (fixed: close button + search)--------------- */}
      <Modal
        className="LocationCardModalSetup"
        show={showModal}
        onHide={closeLocationModal}
        centered
        backdrop="static"
      >
        <Modal.Body className="modal_body">
          <div
            className="closeInvoiceSubs closeInvoiceSubsetupPage"
            onClick={closeLocationModal}
          >
            <img src={closeImg} className="close_modal_img" alt="close" />
          </div>

          <div className="ManageLocationHeading">
            <h2>Manage Location</h2>
          </div>

          <div className="locationSearchBox mb-3">
            <Icon icon="mdi:magnify" className="locationSearchIcon" />
            <input
              type="text"
              placeholder="Search location by name or ID"
              value={locationSearchQuery}
              onChange={(e) => setLocationSearchQuery(e.target.value)}
            />
          </div>

          <div className="locationListScroll">
            {filteredLocationList.length > 0 ? (
              filteredLocationList.map((hotel, index) => (
                <div
                  key={hotel.name || index}
                  className={`locationCardShowDiv ${
                    selectedHotel === hotel.name ? "selected" : ""
                  }`}
                  style={{
                    outline:
                      selectedHotel === hotel.name
                        ? "1px solid var(--primary-600)"
                        : "none",
                  }}
                  onClick={() => handleRadioChange(hotel.name)}
                >
                  <div className="d-flex flex-column align-items-start">
                    <p style={{ fontSize: "16px" }}>{hotel.title}</p>
                    <p style={{ fontSize: "14px" }}>
                      {hotel.name.split("/")[1]}
                    </p>
                  </div>
                  <div className="SelectHotlRedio">
                    <input
                      type="radio"
                      className="redRadio"
                      name="hotelSelection"
                      checked={selectedHotel === hotel.name}
                      onChange={() => handleRadioChange(hotel.name)}
                    />
                  </div>
                </div>
              ))
            ) : (
              <p className="text-muted mb-0 text-center py-3">
                No locations match your search
              </p>
            )}
          </div>

          <div className="SaveCancelLocation">
            <button type="button" onClick={closeLocationModal}>
              Cancel
            </button>
            <button
              type="button"
              className="SavebttnLocatio"
              disabled={!selectedHotel}
              onClick={() => savelocationID()}
            >
              Save
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
